import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../../page/subtask/subtask.component';
import { OperatingproceduresService } from 'src/app/service/operatingprocedures.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, debounceTime, startWith, map } from 'rxjs';
@Component({
  selector: 'app-add-subtask-dialog',
  templateUrl: './add-subtask-dialog.component.html',
  styleUrls: ['./add-subtask-dialog.component.scss'],
  standalone: false,  // NOSONAR
})
export class AddSubtaskDialogComponent implements OnInit {
  taskID;
  subtaskID;
  heading;
  OPData;
  action;
  description;
  catID;
  catDesc;
  OPDesc;
  OPID;
  selectedOP;
  currentOP;
  enableError: boolean = false;
  errormsg;
  temp2: string;
  OPDropdown: any = [];
  OPDataTemp: any = [];
  opFilterControl = new FormControl('');
  // Filtered list displayed in dropdown
  filteredOPDropdown = new BehaviorSubject<any[]>([]);
  constructor(public dialogRef: MatDialogRef<AddSubtaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: DialogData,
    private readonly OPService: OperatingproceduresService, private readonly ngxUiLoaderService: NgxUiLoaderService) {
    //fetch from local-storage
    this.temp2 = localStorage.getItem('OP-data');
    this.OPData = JSON.parse(this.temp2);
    this.OPData?.forEach(element => {
      const obj = { "label": element.description, "value": element.opID };
      this.OPDataTemp.push(obj);
    });
    this.OPDropdown = this.OPDataTemp;
    this.filteredOPDropdown.next(this.OPDropdown.slice());
    if (this.dataStore.performAction == 'EditCell') {  // NOSONAR
      this.heading = "Edit";
      this.taskID = this.dataStore.taskID;
      this.subtaskID = this.dataStore.subtask_id;
      this.description = this.dataStore.placeholderDesc;
      this.action = 'EditCell';
      this.currentOP = this.dataStore.placeholderOP;
      this.OPData?.filter(x => x.opID == this.currentOP).forEach(e => {  // NOSONAR
        this.OPDesc = e.description;
      });
      this.selectedOP = { "label": this.OPDesc, "value": this.currentOP };
    }
    else {
      this.heading = "Add";
      this.taskID = this.dataStore.taskID;
      this.subtaskID = "Auto assigned";
      this.action = 'AddCell';
    }
  }
  ngOnInit(): void {
    this.opFilterControl.valueChanges.pipe(
      debounceTime(200),
      startWith(''),
      map(search => this.filterOptions(search))
    ).subscribe(filtered => {
      this.filteredOPDropdown.next(filtered);
    });
  }
  filterOptions(search: string): any[] {
    const lowercaseSearch = search.toLowerCase();
    return this.OPDropdown.filter(op =>
      op.label?.toLowerCase().includes(lowercaseSearch)
    );
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  close(): void {
    this.dialogRef.close();
  }
  public saveClick() {
    if (this.action == 'AddCell') {  // NOSONAR
      this.OPID = this.selectedOP?.value;
      this.OPData?.filter(x => x.opID == this.OPID).forEach(e => {  // NOSONAR
        this.OPDesc = e.description;
      });
      if (!this.description || this.description.trim().length == 0) {  // NOSONAR
        this.enableError = true;
        this.errormsg = 'Please fill in the required fields!';
      }
      else {
        this.dialogRef.close({ event: this.action, data1: this.description, data2: this.OPID, data3: this.OPDesc });
      }
    }
    if (this.action == 'EditCell') {  // NOSONAR
      if (this.selectedOP) {
        this.OPID = this.selectedOP?.value;
      }
      else {
        this.OPID = this.currentOP;
      }
      this.OPData?.filter(x => x.opID == this.OPID).forEach(e => {  // NOSONAR
        this.OPDesc = e.description;
      });
      if (!this.description || this.description.trim().length == 0) {  // NOSONAR
        this.enableError = true;
        this.errormsg = 'Please fill in the required fields!';
      }
      else {
        this.dialogRef.close({ event: this.action, data1: this.description, data2: this.OPID, data3: this.OPDesc });
      }
    }
  }
}
